<template>
  <div id="app">
    <div class="container-fluid">
      <div class="header">
        <h1>
          Comparison of
          <a
            title="A dynamic graph is a sequence of (static) graphs, each consisting of a set of nodes and a set of edges; edges each connect two nodes in a certain direction"
            >Dynamic Graphs</a
          >
        </h1>
      </div>
      <div class="top-row">
        <Nodelink :bus="bus" cols="col-4" />
        <Grid :bus="bus" cols="col-8" />
      </div>
      <SelectionDetails :bus="bus" cols="col-12" />
    </div>
  </div>
</template>

<script>
import Nodelink from "./components/Nodelink.vue";
import Grid from "./components/Grid.vue";
import SelectionDetails from "./components/SelectionDetails.vue";

export default {
  name: "App",
  components: {
    Nodelink,
    Grid,
    SelectionDetails
  },
  props: {
    bus: { type: Object, required: true }
  }
};
</script>

<style lang="scss">
// Custom Bootstrap overrides
$enable-rounded: false;
$enable-gradients: true;
$font-size-base: 0.75rem;
$grid-gutter-width: 10px;

// Required
@import "~bootstrap/scss/functions";
@import "~bootstrap/scss/variables";
@import "~bootstrap/scss/mixins";

// Optional
@import "~bootstrap/scss/root";
@import "~bootstrap/scss/reboot";
@import "~bootstrap/scss/type";
// @import "~bootstrap/scss/images";
@import "~bootstrap/scss/grid";
@import "~bootstrap/scss/code";
// @import "~bootstrap/scss/tables";
@import "~bootstrap/scss/forms";
@import "~bootstrap/scss/buttons";
@import "~bootstrap/scss/button-group";
@import "~bootstrap/scss/utilities";
@import "~bootstrap/scss/alert";
@import "~bootstrap/scss/card";
@import "~bootstrap/scss/list-group";
@import "~bootstrap/scss/custom-forms";

/*
@import "~bootstrap/scss/close";
@import "~bootstrap/scss/transitions";
@import "~bootstrap/scss/dropdown";
@import "~bootstrap/scss/input-group";
@import "~bootstrap/scss/nav";
@import "~bootstrap/scss/navbar";
@import "~bootstrap/scss/breadcrumb";
@import "~bootstrap/scss/pagination";
@import "~bootstrap/scss/badge";
@import "~bootstrap/scss/jumbotron";
@import "~bootstrap/scss/progress";
@import "~bootstrap/scss/media";
@import "~bootstrap/scss/modal";
@import "~bootstrap/scss/tooltip";
@import "~bootstrap/scss/popover";
@import "~bootstrap/scss/carousel";
@import "~bootstrap/scss/print";*/

body {
  overflow: hidden;
}

.header {
  @include make-row();
  height: 60px;
  padding: 10px;
  background: silver;
}

.top-row {
  @include make-row();
  height: calc(100vh - 207px);
  margin-top: 5px;
  position: relative;
}

.bottom-row {
  @include make-row();
  margin-top: 10px;
}

div.caption {
  height: 3.8em; /*reserves space for two-line captions*/
}

div.caption em,
.card-header em {
  font-size: 1.6em;
  font-style: normal;
}

a {
  text-decoration: underline !important;
}

.card {
  height: 100% !important;
}

.card-header {
  padding: 5px 10px;
}

.card-body {
  padding: 5px;
}

.btn-group {
  display: inline;
}

button {
  float: left;
  border: 1px solid silver;
  padding: 0px 5px;
  margin: 3px;
  height: 20px;
  line-height: 20px;
  background: white;
}

button:hover {
  border: 1px solid black;
  box-shadow: 0px 0px 3px silver;
}
</style>
